import "./ProfileSettings.css"; // ✅ Import styles from ProfileSettings.css
import React from "react";
import arrow from "../../../Assets/icons/arrow_forward_ios.svg"
import { useNavigate } from "react-router-dom";


const SettingsMain = ({ activeToggle, handleToggle, setIsChangePassword }) => {
    return (
        <div className="settingsOptions">
            <div className="option">
                Notifications
                <div
                    className={`toggleContainer ${activeToggle ? "active" : ""}`}
                    onClick={handleToggle}
                >
                    <div className="toggleCircle"></div>
                </div>
            </div>
            <div className="option" onClick={() => setIsChangePassword(true)}>
                Change password
                <img src={arrow} alt="forward" />
            </div>
        </div>
    );
};

export default SettingsMain;
